// extracted by mini-css-extract-plugin
export default {"wrapper":"HC-z","button":"IC-z","alternate":"JC-z","disabled":"KC-z","paymentWarning":"LC-z","fadeIn":"MC-z"};